import { SalonServiceModel } from "./salon-service.models";
import { SALON_SERVICE_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";

export const getServiceList = (branchId: number, salonStaffId?: number) => {
  return apiClient.getHttp<SalonServiceModel[]>(
    SALON_SERVICE_API,
    {
      params: {
        branchId,
        salonStaffId,
      },
    },
    false
  );
};
